module.exports = __webpack_public_path__ + "img/mapmarker.ada87c7a.svg";